import { Typography, styled } from '@mui/material';
import { IField } from '../../../models/form/form';

const Text = styled(Typography)(() => ({
    width: '100%',
}));

interface IFieldProps {
    field: IField;
}

const TextField = ({ field }: IFieldProps) => {
    return <Text>{field.text}</Text>;
};

export default TextField;
